import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form, Button, Modal, Row, Col } from 'react-bootstrap';
import './N.css';
import axios from '../Axiosinstance';
import { ToastContainer, toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const customToastStyles = `
  @media (max-width: 768px) {
    .Toastify__toast-container {
      top: 1rem !important;
      right: 0 !important;
      left: 0 !important;
      bottom: auto !important;
      margin: auto;
      width: fit-content;
    }
  }
  .Toastify__toast {
    border-radius: 12px !important;
  }
`;


const NewVenue = ({ onFormSubmit }) => {
  const navigate = useNavigate();
  const jwtToken = localStorage.getItem('jwtToken');
  const headers = jwtToken ? { Authorization: `Bearer ${jwtToken}` } : {};
  const [formErrors, setFormErrors] = useState({});
  const [formModified, setFormModified] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);
  const [loading, setLoading] = useState(true);
  const [venues, setVenues] = useState([]);
  // const handleSubmit = async (event) => {
  //   event.preventDefault();
  //   const form = event.target;
  //   const formData = new FormData(form);




  //   const errors = {};
  //   if (!formData.get('roomno')) {
  //     errors.roomno = 'Room No is required';
  //   }
  //   if (!formData.get('unit')) {
  //     errors.unit = 'Unit is required';
  //   }
  //   if (!formData.get('block')) {
  //     errors.block = 'Block is required';
  //   }
  //   if (!formData.get('floor')) {
  //     errors.floor = 'Floor is required';
  //   }
  //   if (!formData.get('street')) {
  //     errors.street = 'Street is required';
  //   }
  //   if (!formData.get('building')) {
  //     errors.building = 'Building is required';
  //   }
  //   if (!formData.get('postalcode')) {
  //     errors.postalcode = 'Postal Code is required';
  //   }




  //   if (Object.keys(errors).length > 0) {
  //     setFormErrors(errors);
  //     return;
  //   }




  //   const wheelchair = form.wheelchair.checked ? 'yes' : 'no';




  //   try {
  //     const confirmation = window.confirm('Are you sure you want to add this venue?');
  //     if (confirmation) {
  //     const response = await axios.post('venue', {
  //       ...Object.fromEntries(formData),
  //       wheelchair,
  //     }, { headers });




  //     if (response.status === 200) {
  //       onFormSubmit();
  //     } else {
  //       throw new Error('Failed to add venue');
  //     }
  //   }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };
  useEffect(() => {
    axios
      .get('venues')
      .then((response) => {
        setVenues(response.data.reverse());
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching venues:', error);
        setLoading(false);
      });
  }, []);
  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(form);

    const errors = {};
    if (!formData.get('roomno')) errors.roomno = 'Room No is required';
    if (!formData.get('unit')) errors.unit = 'Unit is required';
    if (!formData.get('block')) errors.block = 'Block is required';
    if (!formData.get('floor')) errors.floor = 'Floor is required';
    if (!formData.get('street')) errors.street = 'Street is required';
    if (!formData.get('building')) errors.building = 'Building is required';
    if (!formData.get('postalcode')) errors.postalcode = 'Postal Code is required';

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    const wheelchair = form.wheelchair.checked ? 'yes' : 'no';

    const newVenue = {
      roomno: formData.get('roomno'),
      unit: formData.get('unit'),
      block: formData.get('block'),
      floor: formData.get('floor'),
      street: formData.get('street'),
      building: formData.get('building'),
      postalcode: formData.get('postalcode'),
      wheelchair,
    };

    // Check for exact duplicate
    const isDuplicate = venues.some((venue) =>
      venue.roomno === newVenue.roomno &&
      venue.unit === newVenue.unit &&
      venue.block === newVenue.block &&
      venue.floor === newVenue.floor &&
      venue.street === newVenue.street &&
      venue.building === newVenue.building &&
      venue.postalcode === newVenue.postalcode
      // venue.wheelchair === newVenue.wheelchair
    );

    if (isDuplicate) {
      toast.warning("Venue already exists with identical details");
      return;
    }

    try {
      const response = await axios.post('venue', newVenue, { headers });
      if (response.status === 200) {
        onFormSubmit();
        toast.success("Venue added successfully");
      } else {
        throw new Error('Failed to add venue');
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while adding the venue");
    }
  };


  const handleCancel = () => {
    handleCloseModal();
    navigate('/Adhome'); // Replace this with the route to navigate when canceled
  };

  useEffect(() => {
    const handleFormModification = () => {
      if (!formModified) {
        setFormModified(true);
      }
    };



    return () => {
      window.removeEventListener('input', handleFormModification);
    };
  }, [formModified]);


  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (formModified) {
        event.returnValue = 'You have unsaved changes. Are you sure you want to leave this page?';
      }
    };


    window.onbeforeunload = handleBeforeUnload;

    return () => {
      window.onbeforeunload = null;
    };
  }, [formModified]);

  const handleInputChange = (e) => {
    const inputName = e.target.name;
    let inputValue = e.target.value;

    // If the input is roomno, unit, block, floor, or postalcode, restrict to digits and 8 characters
    if (['roomno', 'unit', 'floor', 'postalcode'].includes(inputName)) {
      inputValue = inputValue.replace(/\D/g, '').substring(0, 8); // Allow only digits and limit to 8 characters
    } else if (['block'].includes(inputName)) {
      inputValue = inputValue.substring(0, 20);
    }

    // Update the input value in the form
    e.target.value = inputValue;
    setFormErrors({});
  };








  const styles = {
    container: {
      maxWidth: "1080px",
      margin: "0 auto",
      padding: "40px",
      border: "1px solid #ddd",
      borderRadius: "8px",
      backgroundColor: "#f9f9f9",
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    },








  };




  return (

    <div className="" >
      <br></br>
      <div style={styles.container}>

        <h4 style={{ marginTop: '-1%' }}>New Venue  (Jurong Academy)</h4>


        <br />
        <Form onSubmit={handleSubmit} style={{ maxWidth: '1200px' }}>
          <Row>
            {/* Room No */}
            <Col md={6}>
              <Form.Group controlId="roomNo">
                <Form.Label>Room No<span style={{ color: 'red' }}>*</span></Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter Room No"
                  name="roomno"
                  required
                  onChange={handleInputChange}
                  isInvalid={!!formErrors.roomno}
                  onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                />
                <Form.Control.Feedback type="invalid">
                  {formErrors.roomno}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Unit */}
            <Col md={6}>
              <Form.Group controlId="unit">
                <Form.Label>Unit<span style={{ color: 'red' }}>*</span></Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter Unit"
                  name="unit"
                  required
                  onChange={handleInputChange}
                  isInvalid={!!formErrors.unit}
                  onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                />
                <Form.Control.Feedback type="invalid">
                  {formErrors.unit}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            {/* Block */}
            <Col md={6}>
              <Form.Group controlId="block">
                <Form.Label>Block<span style={{ color: 'red' }}>*</span></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Block"
                  name="block"
                  required
                  onChange={handleInputChange}
                  isInvalid={!!formErrors.block}
                />
                <Form.Control.Feedback type="invalid">
                  {formErrors.block}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Floor */}
            <Col md={6}>
              <Form.Group controlId="floor">
                <Form.Label>Floor<span style={{ color: 'red' }}>*</span></Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter Floor"
                  name="floor"
                  required
                  onChange={handleInputChange}
                  isInvalid={!!formErrors.floor}
                  onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                />
                <Form.Control.Feedback type="invalid">
                  {formErrors.floor}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            {/* Street */}
            <Col md={6}>
              <Form.Group controlId="street">
                <Form.Label>Street<span style={{ color: 'red' }}>*</span></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Street"
                  name="street"
                  required
                  onChange={handleInputChange}
                  isInvalid={!!formErrors.street}
                />
                <Form.Control.Feedback type="invalid">
                  {formErrors.street}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Building */}
            <Col md={6}>
              <Form.Group controlId="building">
                <Form.Label>Building<span style={{ color: 'red' }}>*</span></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Building"
                  name="building"
                  required
                  onChange={handleInputChange}
                  isInvalid={!!formErrors.building}
                />
                <Form.Control.Feedback type="invalid">
                  {formErrors.building}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            {/* Postal Code */}
            <Col md={6}>
              <Form.Group controlId="postalcode">
                <Form.Label>Postal Code<span style={{ color: 'red' }}>*</span></Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter Postal Code"
                  name="postalcode"
                  required
                  onChange={handleInputChange}
                  isInvalid={!!formErrors.postalcode}
                  onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                />
                <Form.Control.Feedback type="invalid">
                  {formErrors.postalcode}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Wheelchair Access */}
            <Col md={6}>
              <Form.Group controlId="checkbox" className="mt-4">
                <Form.Check type="checkbox" label="Wheelchair access" name="wheelchair" />
              </Form.Group>
            </Col>
          </Row>

          <br />

          {/* Buttons */}
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>

            <button
              type="button"
              className="btn-cancel"
              onClick={handleShowModal}
              style={{
                marginRight: '1%',
                backgroundColor: 'red',
                color: 'white',
                fontSize: '15px',
                border: 'none',
                padding: '8px 35px',
                borderRadius: '7px',
              }}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="btn-submit"
              style={{

                fontSize: '15px',
                border: 'none',
                padding: '8px 35px',
                borderRadius: '7px',
                backgroundColor: 'green',
                color: 'white',
              }}
            >
              Submit
            </button>

          </div>


        </Form>


        <Modal show={showModal} onHide={handleCloseModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>Cancel Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Are you sure you want to cancel?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleCloseModal}>
              No
            </Button>
            <Button variant="danger" onClick={handleCancel} style={{ backgroundColor: 'red', color: 'white' }}>
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <>
        <style>{customToastStyles}</style>
        <ToastContainer
          position="bottom-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          transition={Slide}
        />
      </>
    </div>
  );
};


const New = ({ onFormSubmit }) => {
  return (
    <div>

      <br></br>
      <NewVenue onFormSubmit={onFormSubmit} />
    </div>
  );
};


export default New;





